import React from "react"

export function Home(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.7445 6.98633C15.7445 7.47852 15.3344 7.86406 14.8695 7.86406H13.9945L14.0137 12.2445C14.0137 12.3184 14.0082 12.3922 14 12.466V12.9062C14 13.5105 13.5105 14 12.9062 14H12.4688C12.4387 14 12.4086 14 12.3785 13.9973C12.3402 14 12.302 14 12.2637 14H11.375H10.7188C10.1145 14 9.625 13.5105 9.625 12.9062V12.25V10.5C9.625 10.016 9.23398 9.625 8.75 9.625H7C6.51602 9.625 6.125 10.016 6.125 10.5V12.25V12.9062C6.125 13.5105 5.63555 14 5.03125 14H4.375H3.50273C3.46172 14 3.4207 13.9973 3.37969 13.9945C3.34687 13.9973 3.31406 14 3.28125 14H2.84375C2.23945 14 1.75 13.5105 1.75 12.9062V9.84375C1.75 9.81914 1.75 9.7918 1.75273 9.76719V7.86406H0.875C0.382812 7.86406 0 7.48125 0 6.98633C0 6.74023 0.0820312 6.52148 0.273438 6.33008L7.28437 0.21875C7.47578 0.0273438 7.69453 0 7.88594 0C8.07734 0 8.29609 0.0546875 8.46016 0.191406L15.4437 6.33008C15.6625 6.52148 15.7719 6.74023 15.7445 6.98633Z"
        fill="currectColor"
      />
    </svg>
  )
}
